import { createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { ManualEntriesRepository } from '~/repositories/manualEntriesRepository';
import type {
  CreateManualJournalEntryRequestDto,
  UpdateManualJournalEntryRequestDto,
  SubmitManualJournalEntryRequestDto,
  ApproveManualJournalEntryRequestDto,
  RejectManualJournalEntryRequestDto,
  PostManualJournalEntryRequestDto,
  GetManualJournalEntriesParams,
} from '~/swagger/accounting/Api';

const repo = new ManualEntriesRepository();

export const [ManualEntriesProvider, useManualEntries] = createMagicDoorContext('ManualEntries', () => {
  const [filtered, setFilter, actions] = createTriggerResource((filter?: GetManualJournalEntriesParams) =>
    repo.getManualJournalEntries(filter)
  );

  const createManualJournalEntry = async (payload: CreateManualJournalEntryRequestDto) => {
    return await repo.createManualJournalEntry(payload);
  };

  const updateManualJournalEntry = async (manualJournalEntryId: string, payload: UpdateManualJournalEntryRequestDto) => {
    return await repo.updateManualJournalEntry(manualJournalEntryId, payload);
  };

  const getManualJournalEntry = async (manualJournalEntryId: string) => {
    return await repo.getManualJournalEntry(manualJournalEntryId);
  };

  const deleteManualJournalEntry = async (manualJournalEntryId: string) => {
    await repo.deleteManualJournalEntry(manualJournalEntryId);
  };

  const submitManualJournalEntry = async (manualJournalEntryId: string, payload: SubmitManualJournalEntryRequestDto) => {
    return await repo.submitManualJournalEntry(manualJournalEntryId, payload);
  };

  const approveManualJournalEntry = async (manualJournalEntryId: string, payload: ApproveManualJournalEntryRequestDto) => {
    return await repo.approveManualJournalEntry(manualJournalEntryId, payload);
  };

  const rejectManualJournalEntry = async (manualJournalEntryId: string, payload: RejectManualJournalEntryRequestDto) => {
    return await repo.rejectManualJournalEntry(manualJournalEntryId, payload);
  };

  const postManualJournalEntry = async (manualJournalEntryId: string, payload: PostManualJournalEntryRequestDto) => {
    return await repo.postManualJournalEntry(manualJournalEntryId, payload);
  };

  return {
    filtered,
    setFilter: (filter: GetManualJournalEntriesParams) => setFilter(filter),
    refetch: actions.refetch,
    createManualJournalEntry,
    updateManualJournalEntry,
    getManualJournalEntry,
    deleteManualJournalEntry,
    submitManualJournalEntry,
    approveManualJournalEntry,
    rejectManualJournalEntry,
    postManualJournalEntry,
  };
});
